import React from 'react';
import { Auto } from 'fw/forms';

class MultiAuto extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
            value: this.props.value || [],
            invalid: false
        };
	}

    // Public
    setValue = (value) => {
        this.setState({ value: value });
    }

    getValue = () => {
        return this.state.value;
    }

    focus = () => {
        this._select.focus();
    }

    flag = (status) => {
        this._select.flag(status);
	}

	completed = () => {
		return !((this.state.value === null || this.state.value.length <= 0) && this.props.required)
	}

    validate = () => {
        return null;
    }

    // Private
    _update = (value) => {
		this.setState({ value: value }, () => {
			const validationResult = this.validate();
			const requiredPassed = this.completed();
			const validationPassed = (validationResult === null || validationResult === undefined);
			const status = requiredPassed && validationPassed;

            // Show error status if neccesary
			this.flag(status);

			// Trigger standard onChange...
			this.props.onChange && this.props.onChange(value);
			this.props.managed && this.props.onFieldChange(value, this.props.name);
		});
	}

    _handleOnChange = value => {
        this._update(value);

        this.props.onDirt && this.props.onDirt();
    }

    _handleInputFocus = (e) => {
        this.props.onFocus && this.props.onFocus();
    }

    _handleInputBlur = (e) => {
        this.props.onBlur && this.props.onBlur();
	}

	componentWillReceiveProps(nextProps, nextState) {
		if (nextProps.value !== this.props.value)
			this.setState({ value: nextProps.value });
	}

    // React
    render() {
        // GetLabel is the method to render every email string
        const props = {
            id: this.props.id,
            value: this.state.value,
            name: this.props.name,
            placeholder: this.props.placeholder,
            onChange: this._handleOnChange,
            required: this.props.required,
            disabled: this.props.disabled,
            onFocus: this._handleInputFocus,
            onBlur: this._handleInputBlur,
            loader: this.props.loader,
            isMulti: true
        }

        return (
            <Auto {...props} ref={select => this._select = select} />
        );
    }
}

// Mark this as a form component
MultiAuto.defaultProps = {
	formControl: true,
	managed: false,
	clearable: false
};

export default MultiAuto;



// WEBPACK FOOTER //
// ./src/fw/forms/controls/multiAuto/MultiAuto.js